import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=4effcb7d&scoped=true&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"
import style0 from "./modal.vue?vue&type=style&index=0&id=4effcb7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effcb7d",
  null
  
)

export default component.exports